import { Component } from '@angular/core';

@Component({
	selector: 'dix-loading-logo',
	templateUrl: './loading-logo.component.html',
	styleUrl: './loading-logo.component.scss',
})
export class LoadingLogoComponent {}
